import axios, { AxiosResponse } from 'axios';

import { HttpRequestParams } from '../utils/interfaces/http-request-params.interface';

/**
 * Class responsible for making aws api restful requests
 */
export class RequestClientInterfaceService {
    controller: AbortController;
    constructor() {
        this.controller = new AbortController();
    }
    /**
     * This method send and http request to the external API
     * @param requestData required params to send an Axios http call
     */
    public async sendRequest<T>(
        requestData: HttpRequestParams,
    ): Promise<AxiosResponse<T>> {
        try {
            return await axios.request({
                ...requestData,
                signal: this.controller.signal,
            });
        } catch (err) {
            throw err as Error;
        }
    }

    public async cancelReqeust() {
        this.controller.abort();
    }
}
